import React from "react";

const LEVEL_ICONS = ["🔎", "🤔", "🧠", "🔗", "💭"];

export default function ProgressBar({ currentLevel, levelScores = [0, 0, 0, 0, 0] }) {
  return (
    <div className="flex items-center justify-center gap-2 sm:gap-3 py-2">
      {LEVEL_ICONS.map((icon, idx) => {
        const levelNum = idx + 1;
        const done = levelScores[idx] > 0;
        const active = levelNum === currentLevel;
        return (
          <div
            key={levelNum}
            className={[
              "flex items-center justify-center rounded-full transition-all duration-300",
              "w-8 h-8 sm:w-10 sm:h-10 text-sm sm:text-base",
              done ? "bg-[#4ADE80] text-white" : active ? "bg-[#7C3AED] text-white scale-110 shadow-md" : "bg-[#F3EEFF] text-[#7C3AED]",
            ].join(" ")}
            aria-label={`Level ${levelNum}${done ? " complete" : active ? " current" : ""}`}
          >
            {done ? "✓" : icon}
          </div>
        );
      })}
    </div>
  );
}
